import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Formsy from 'formsy-react';
import TextInput from 'components/inputs/TextInput';
import SearchIcon from '@mui/icons-material/Search';
import { Dialog, DialogTitle, Button } from '@mui/material';
import { FormattedMessage, injectIntl } from 'react-intl';

export class SearchWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleOpen() {
    this.setState({open: true});
  }

  handleClose() {
    document.activeElement.blur(); // Remove focus from input causing accessibility warning
    this.setState({open: false});
  }

  handleSearch(data) {
    this.handleClose();
    this.props.navigateTo(`/search?search=${data.search || ''}`);
  }

  render() {
    const { intl } = this.props;
    const { open } = this.state;

    return (
      <React.Fragment>
        <SearchIcon onClick={this.handleOpen} tabIndex="0" className="cursor" style={{margin: '0 15px'}} />
        <Dialog open={open} onClose={this.handleClose} aria-label={intl.formatMessage({id: "search.products", defaultMessage: "Search Products"})} fullWidth maxWidth="xs">
          <DialogTitle>
            <center>
              <FormattedMessage id="search.products" defaultMessage="Search Products" />
            </center>
          </DialogTitle>
          <div style={{padding: '0 20px 20px 20px'}}>
            <Formsy onValidSubmit={this.handleSearch} className="full-width">
              <TextInput name="search" autoFocus
                label={intl.formatMessage({id: "order.search", defaultMessage: "Search"})}
              />
              <center style={{marginTop: '15px'}}>
                <Button type="submit" variant="contained" color="primary">
                  <FormattedMessage id="order.search" defaultMessage="Search" />
                </Button>
              </center>
            </Formsy>
          </div>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  navigateTo: (path) => push(path)
}

export default connect(null, mapDispatchToProps)(injectIntl(SearchWidget));
